var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from "./BaseModel";
import DefaultChoiceModel from "./DefaultChoiceModel";
var MasterOptionExceptionModel = /** @class */ (function (_super) {
    __extends(MasterOptionExceptionModel, _super);
    function MasterOptionExceptionModel(data) {
        var _this = _super.call(this, data) || this;
        _this.choices = {};
        _this.defaultChoices = {};
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.id;
        _this.basePrice = hydrated.basePrice;
        _this.choices = hydrated.choices;
        _this.defaultChoices = hydrated.defaultChoices;
        _this.exclusive = hydrated.exclusive;
        _this.freeChoicesCount = hydrated.freeChoicesCount;
        _this.required = hydrated.required;
        _this.__mc = 'MasterOptionExceptionModel';
        return _this;
    }
    MasterOptionExceptionModel.prototype.hydrate = function (data) {
        var masterOptionException = {
            defaultChoices: {},
            choices: {}
        };
        masterOptionException.id = data.option_id;
        masterOptionException.basePrice = parseInt(data.base_price) || 0;
        for (var id in data.choices) {
            masterOptionException.choices[id] = new DefaultChoiceModel(data.choices[id]);
        }
        masterOptionException.exclusive = !!+(data.exclusive);
        masterOptionException.required = !!+(data.required);
        masterOptionException.freeChoicesCount = parseInt(data.free_choices_count) || 0;
        var defaultChoices = data.default_choices;
        for (var id in defaultChoices) {
            masterOptionException.defaultChoices[id] = new DefaultChoiceModel(defaultChoices[id]);
        }
        return masterOptionException;
    };
    MasterOptionExceptionModel.prototype.hydrateFromStore = function (data) {
        return data;
    };
    MasterOptionExceptionModel.prototype.isChoiceIncluded = function (choiceId) {
        return this.defaultChoices[choiceId].included;
    };
    MasterOptionExceptionModel.prototype.allChoicesIncluded = function () {
        var choiceCount = Object.keys(this.defaultChoices).length;
        var falseCount = 0;
        var trueCount = 0;
        for (var id in this.defaultChoices) {
            if (!this.defaultChoices[id].included) {
                falseCount++;
            }
            else {
                trueCount++;
            }
        }
        return falseCount === choiceCount || trueCount === choiceCount;
    };
    MasterOptionExceptionModel.prototype.getChoice = function (choiceId) {
        return this.choices[choiceId];
    };
    MasterOptionExceptionModel.prototype.getDefaultChoice = function (choiceId) {
        return this.defaultChoices[choiceId];
    };
    return MasterOptionExceptionModel;
}(BaseModel));
export default MasterOptionExceptionModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/MasterOptionExceptionModel.ts
// module id = bFns
// module chunks = 18